module.exports = __webpack_public_path__ + "57fb1d978a141de9069c399cac72f092.svg";